import type { ButtonHTMLAttributes } from "react";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "danger" | "ghost";
}

export function Button({ variant = "primary", className = "", ...rest }: ButtonProps): JSX.Element {
  const base =
    "inline-flex items-center justify-center font-mono text-[11px] uppercase tracking-widest2 px-4 py-2 border transition-colors disabled:opacity-40 disabled:cursor-not-allowed";
  const variants: Record<string, string> = {
    primary:
      "bg-vinyl text-paper border-vinyl hover:bg-paper hover:text-asphalt hover:border-paper",
    secondary: "bg-transparent text-paper border-border hover:border-paper hover:bg-tapeElev",
    danger: "bg-transparent text-vinyl border-vinyl hover:bg-vinyl hover:text-paper",
    ghost: "bg-transparent text-ink-muted border-transparent hover:text-paper",
  };
  return <button className={`${base} ${variants[variant]} ${className}`} {...rest} />;
}
